import React, { useState, useEffect, useRef } from 'react';
import Sidebar from './Sidebar';
import houseThumb from '../assets/ngoinha1.png';
import aromaImg from '../assets/aroma.png';
import airImg from '../assets/air.png';
import humiImg from '../assets/humi.png';
import speakerImg from '../assets/speaker.png';
import lampImg from '../assets/smartlamp.png';

const ConnectDevices = ({ isVisible, onBack, onContinue, onLogout, onAddDevice, connectedDevices, onDeleteDevice }) => {
  
  const [devices, setDevices] = useState([
    { id: 1, name: 'Aroma Diffuser', type: 'Diffuser', status: 'not connected' },
    { id: 2, name: 'Air Conditioner', type: 'AC', status: 'not connected' },
    { id: 3, name: 'Humidifier', type: 'Humidifier', status: 'not connected' },
    { id: 4, name: 'Speaker', type: 'Speaker', status: 'not connected' },
    { id: 5, name: 'Smart Lamp', type: 'Lamp', status: 'not connected' },
    { id: 6, name: 'Smart Lamp', type: 'Lamp', status: 'not connected' },
  ]);

  // --- State cho tìm kiếm ---
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const searchRef = useRef(null); // Để xử lý click ra ngoài thì đóng dropdown

  // Lọc danh sách thiết bị theo từ khóa
  const filteredResults = devices.filter(device => 
    device.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Xử lý click ra ngoài để đóng dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!isVisible) return null;

  // Hàm lấy hình ảnh thiết bị
  const getDeviceImage = (type) => {
    switch(type) {
        case 'Diffuser': return aromaImg;
        case 'AC': return airImg;
        case 'Humidifier': return humiImg;
        case 'Speaker': return speakerImg;
        case 'Lamp': return lampImg;
        default: return null;
    }
  };

  // Hàm render Icon nhỏ cho phần tìm kiếm (fallback nếu không có hình)
  const renderSmallIcon = (type) => {
    switch(type) {
        case 'Diffuser': return '🌬️';
        case 'AC': return '❄️';
        case 'Humidifier': return '💧';
        case 'Speaker': return '🔊';
        case 'Lamp': return '💡';
        default: return '🔌';
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar activeId="devices" onLogout={onLogout} />

      <div className="main-content setup-layout">
        
        {/* Header giữ nguyên */}
        <div className="setup-header">
          <button className="back-btn" onClick={onBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          </button>
          <div className="header-titles">
            <h2>Create a new space</h2>
            <p>Connect your devices</p>
          </div>
          <div className="step-indicator">Step <strong>4 | 7</strong></div>
        </div>

        <div className="setup-body column-mode">
          
          {/* Summary Card giữ nguyên */}
          <div className="summary-card">
            <div className="summary-left">
              <img src={houseThumb} alt="House" className="summary-thumb" />
              <div className="summary-info">
                <h3 className="house-title">My Home <span className="edit-icon">✎</span></h3>
                <p className="house-address">11-5 Raddington Rd, London, UK</p>
              </div>
            </div>
            <div className="summary-stats">
              <div className="stat-pill"><span className="dot green"></span> 4 Rooms</div>
              <div className="stat-pill"><span className="dot blue"></span> {connectedDevices.length} Devices</div>
              <div className="stat-pill"><span className="dot grey"></span> 0 Members</div>
            </div>
          </div>

          <div className="device-section-header">
            <div className="text-group">
              <h3>Link smart devices</h3>
              <p>Current devices nearby</p>
            </div>
            
            {/* --- SEARCH BOX CÓ DROPDOWN --- */}
            <div className="search-box" ref={searchRef}>
              <input 
                type="text" 
                placeholder="Search" 
                value={searchTerm}
                onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setShowDropdown(e.target.value.length > 0);
                }}
                onFocus={() => {
                    if (searchTerm.length > 0) setShowDropdown(true);
                }}
              />
              <svg className="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>

              {/* DROPDOWN KẾT QUẢ TÌM KIẾM */}
              {showDropdown && (
                <div className="search-dropdown">
                  <div className="dropdown-header">All results</div>
                  
                  {filteredResults.length > 0 ? (
                    <div className="dropdown-list">
                      {filteredResults.map(device => {
                        const isConnected = connectedDevices.includes(device.id);
                        return (
                          <div key={device.id} className="search-result-item">
                            {/* Icon thiết bị */}
                            <div className="result-icon-wrapper">
                                {getDeviceImage(device.type) ? (
                                    <img src={getDeviceImage(device.type)} alt={device.name} style={{width: '100%', height: '100%', objectFit: 'contain'}} />
                                ) : (
                                    renderSmallIcon(device.type)
                                )}
                            </div>

                            {/* Thông tin tên và trạng thái */}
                            <div className="result-info">
                              <span className="result-name">{device.name}</span>
                              <span className={`result-status ${isConnected ? 'green' : 'grey'}`}>
                                {isConnected ? (
                                    <>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: 4}}><polyline points="20 6 9 17 4 12"/></svg>
                                        connected
                                    </>
                                ) : (
                                    <>
                                        <span style={{marginRight: 4}}>-</span> not connected
                                    </>
                                )}
                              </span>
                            </div>

                            {/* Nút hành động (Add hoặc Delete) */}
                            <div className="result-action">
                                {isConnected ? (
                                    <button className="action-btn remove" onClick={() => onDeleteDevice(device.id, device.name)}>
                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                    </button>
                                ) : (
                                    <button className="action-btn add" onClick={() => {
                                        onAddDevice(device.id);
                                        setShowDropdown(false); // Đóng dropdown sau khi chọn
                                    }}>
                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                    </button>
                                )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="no-results">No devices found</div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Lưới thiết bị bên dưới (Giữ nguyên) */}
          <div className="device-grid">
            {devices.map((device) => {
              const isConnected = connectedDevices.includes(device.id);
              return (
                <div key={device.id} className={`device-card ${isConnected ? 'connected' : ''}`}>
                  {/* ... Code phần grid item giữ nguyên như cũ ... */}
                  <div className="device-image-placeholder">
                     {getDeviceImage(device.type) ? (
                        <img src={getDeviceImage(device.type)} alt={device.name} style={{width: '100%', height: '100%', objectFit: 'contain', padding: '10px'}} />
                     ) : (
                        <div className="device-icon-circle">{renderSmallIcon(device.type)}</div>
                     )}
                  </div>
                  <div className="device-details">
                    <h4>{device.name}</h4>
                    <p className="status">
                      {isConnected ? (
                        <span className="status-connected">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '4px'}}><polyline points="20 6 9 17 4 12"/></svg>
                          connected
                        </span>
                      ) : (
                        <><span className="status-dash">-</span> {device.status}</>
                      )}
                    </p>
                  </div>
                  {isConnected ? (
                    <button className="delete-btn" onClick={() => onDeleteDevice(device.id, device.name)}>
                       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
                    </button>
                  ) : (
                    <button className="add-btn" onClick={() => onAddDevice(device.id)}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a73e8" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    </button>
                  )}
                </div>
              );
            })}
          </div>

        </div>

        {/* Footer giữ nguyên */}
        <div className="setup-footer">
          <div className="footer-content">
            <span className="footer-hint">Add all your devices and go to the next step.</span>
            <div className="footer-actions">
              <button className="secondary-btn" onClick={onContinue}>Skip</button>
              <button className="primary-btn continue-btn" onClick={onContinue}>Continue</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectDevices;